import store from '@/store'
import os from '@utils/os'
import { NativeMessagePush, NativeMessageData } from '@utils/nativeBridge/nativeMessage'
let isFirst = true // 判断是不是第一次进入
let onLineTimer = null
export default {
  type: 'pageConfig',
  path: ['*'],
  handler(info) {
    return new Promise(async (resolve, reject) => {
      const { getters } = store
      const { to, from } = info
      if (getters.isLogin === undefined) await store.dispatch('user/getLoginStatus').catch(_ => _)

      if (getters.isLogin && !getters.userInfo) {
        await store.dispatch('user/getUserInfos').catch(e => e)
      }

      if (os.isWechat() != 3 && !getters.wxConfig)
        if (os.isIOS() && getters.isInApp) {
          /*await*/
          // store.dispatch('wechat/setWXConfig').catch(_ => _)
          // if (getters.isLogin && getters.userIdentity == -1)
          //   /*await*/ store.dispatch("user/checkUserIdentity").catch((_) => _);
          // await store.dispatch('getappversion').catch((_) => _)
        }
      const { title = '' } = to.meta

      document.title = ''
      store.getters.wx.share({
        title
      })

      store.commit('showLoading')

      store.commit(
        'setShowTabbar',
        store.getters.isInApp &&
          (to.path === '/videoConferencing' ||
            to.path === '/personalCenter' ||
            to.path === '/' ||
            to.path === '/test' ||
            to.path === '/openingPublicity' ||
            to.path === '/stCommonwealth' ||
            (to.path === '/openingPublicitySuccess' && to.query.showTabbar == 0) ||
            (to.path === '/doctorMainPage' && to.query.showTabbar == 0))
      )
      // 处理默认选中科联体

      // if (store.state.user.userInfos.doctor_id && store.getters.isInApp && getters.isLogin && isFirst && !to.query.isHome) {
      //   console.log(store.state.common.isDeptUnion, '000000')
      //   isFirst = false
      //   if (to.path === "/") {
      //     await store.dispatch("getisDeptUnion", {
      //       doctorId: store.state.user.userInfos.doctor_id
      //     }).then(res => {
      //       if (res.result.total) {
      //         store.commit('setdeptUnionId', res.result.records[0].id)
      //         console.log(store.state.common.isDeptUnion, '0000001')
      //         if (!store.state.common.verticallHung) { store.commit('setTabbarSelectedIndex', 0) } else {
      //           store.commit(
      //             "setShowTabbar",
      //             false)
      //         }
      //       } else {
      //         store.dispatch('stCommonwealth/getStatus').then(res => {
      //           if (res.result.records && res.result.records.length) {
      //             console.log(store.state.common.verticallHung, '0000002')
      //             if (!store.state.common.verticallHung) { store.commit('setTabbarSelectedIndex', 0) } else {
      //               store.commit(
      //                 "setShowTabbar",
      //                 false)
      //             }
      //             store.commit('setdeptUnionId', res.result.records[0].deptUnionId)
      //           }
      //         })
      //       }
      //     })
      //   }
      // }

      if (store.getters.isInApp && getters.isLogin) {
        let number = store.getters.nativeBridge.sendMessage(
          new NativeMessageData({
            type: 'getConsultantChatUnreadMessageNumber'
          })
        )
        console.log(number, '获取顾问在线未读消息数')
        store.commit('messagePush/setUnreadMessages', number)
      }
      // setTimeout(() => {
      //   if (!onLineTimer && getters.isLogin) {
      //     store.dispatch('user/iOnLine')
      //     onLineTimer = setInterval(() => {
      //       store.dispatch('user/iOnLine')
      //     }, 4 * 60 * 1000)
      //   } else if (!getters.isLogin && onLineTimer) {
      //     clearInterval(onLineTimer)
      //     onLineTimer = null
      //   }
      // }, 0)

      resolve()
    })
  }
}
